import React, { useState } from "react";
import ViewButton from "../Buttons/ViewButton";
import CheckWithDate from "../CheckWithDate";
import StandardDrawer from "../forms/StandardDrawer";
import ViewTreatmentEngagementPolicy from "../forms/ViewTreatmentEngagementPolicy";

function FormLineTreatmentEngagment(props) {

  const [showViewModal, setShowViewModal] = useState(false);

  const openViewModal = () => {
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
  };

  const handleRowKeyDown = (event) => {
    if (props.signed && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      openViewModal();
    }
  };

  return (
    <div
      className={
        `${
          props.color === "1" ? "formLine light-grey-form" : "formLine grey-form"
        } ${props.signed ? "form-row-clickable" : ""}`
      }
      onClick={props.signed ? openViewModal : undefined}
      onKeyDown={handleRowKeyDown}
      role={props.signed ? "button" : undefined}
      tabIndex={props.signed ? 0 : undefined}
    >
      <StandardDrawer open={showViewModal} onClose={closeViewModal}>
        <ViewTreatmentEngagementPolicy {...props} closemodal={closeViewModal} />
      </StandardDrawer>
      <div className="formLineBlock1">{props.title}</div>
      <div className="formLineBlock2">
        {props.signed !== true || props.signed === undefined ? (
          <CheckWithDate checked={false} content="Not signed" />
        ) : (
          <CheckWithDate checked={true} content={props.date} />
        )}
      </div>
      <div className="formLineBlock3">
        {props.signed ? (
          <ViewButton handleOpen={openViewModal} {...props} />
        ) : (
          ""
        )}

        {/* <DownloadButton2 /> */}

        {/* <CheckButton />
        <PrintButton />
        <MailButton /> */}
      </div>
    </div>
  );
}

export default FormLineTreatmentEngagment;
